import { render, staticRenderFns } from "./AppLayoutColumnsBlock.vue?vue&type=template&id=58ede4e9&scoped=true"
import script from "./AppLayoutColumnsBlock.vue?vue&type=script&lang=js"
export * from "./AppLayoutColumnsBlock.vue?vue&type=script&lang=js"
import style0 from "./AppLayoutColumnsBlock.vue?vue&type=style&index=0&id=58ede4e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ede4e9",
  null
  
)

export default component.exports